import { Card, CardBody, CardHeader, EmptyState } from '../../components/ui'
import { UsersGroupIcon } from '../../components/icons'

/* Joining a cooperative is no longer self-service.
 *
 * Membership is assigned by the platform administrator - a person cannot
 * apply, and a cooperative cannot recruit (see role_service.assignable_roles
 * and api_create_allocation_request, both of which now refuse). The route is
 * kept rather than deleted so an old bookmark, a stale PWA shortcut or a link
 * in a past notification lands on an explanation instead of a 404. */
export default function FindCooperative() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1>Cooperative membership</h1>
          <p className="page-head__sub">
            How to be added to a cooperative on SSM Zambia.
          </p>
        </div>
      </div>

      <Card>
        <CardHeader title="Assigned by the administrator" />
        <CardBody>
          <EmptyState
            icon={<UsersGroupIcon size={22} />}
            title="Membership is assigned, not requested"
            body={
              'Every account is placed in its cooperative or company by the platform '
              + 'administrator. There is no application to submit here. Contact the '
              + 'administrator, or your cooperative’s leadership, and ask them to have '
              + 'your account assigned — once that is done your cooperative appears '
              + 'across the app automatically.'
            }
          />
        </CardBody>
      </Card>
    </>
  )
}
